import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dn_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("dn_cart", JSON.stringify(items)); }, [items]);

  const add = (product, size) => {
    setItems((prev) => {
      const key = product.slug + "|" + (size || "");
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, {
        key, slug: product.slug, name: product.name, price: product.price,
        image: product.image, size: size || null, quantity: 1,
      }];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const setQty = (key, q) => setItems((p) => p.map((i) => i.key === key ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
